import Axios from 'axios'

const pdf = {
  sendPaternityInfo (operator) {
    return Axios({
      method: 'post',
      url: '/report/form-paternity',
      responseType: 'arraybuffer',
      data: operator
    })
  }
}

export default pdf
